import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes/index";

const env = import.meta.env;

const router = createRouter({
	history: env.VITE_APP_ENV !== 'development' ? createWebHistory() : createWebHistory(env.BASE_URL),
	routes: [
		...routes,
		{
			path: '/:pathMatch(.*)',
			name: '404',
			component: () => import('@h5-monorepo/shared/components/404.vue')
		}
	]
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // if (to.fullPath == '/' || to.fullPath == '') {
  //   window.location.replace('https://docoi.cc')
  // } else {
  next(); // 继续导航
  // }
});
router.afterEach((to, from) => {
  document.title = (to.meta?.title as string) || "";
});

export default router;
